import { fork } from 'redux-saga/effects';
import { customersSagas } from './customersSagas';
import { filtersConfigWatcher } from './filtersSaga';
import { dadataBankWatcher } from '../../modules/dadataBank/sagas';
import { fieldsConfigWatcher } from './fieldsConfigSagas';

export default function* Customers() {
  yield fork(customersSagas);
  yield fork(dadataBankWatcher);
  yield fork(fieldsConfigWatcher);
  yield fork(filtersConfigWatcher);
}
